import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BannerComponent } from './pages/banner/banner.component';
import { ConsultationComponent } from './pages/consultation/consultation.component';
import { CareerComponent } from './pages/career/career.component';
import { RewardComponent } from './pages/reward/reward.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { ShippingPolicyComponent } from './pages/shipping-policy/shipping-policy.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';
import { ReturnsAndRefundComponent } from './pages/returns-and-refund/returns-and-refund.component';
import { FaqComponent } from './pages/faq/faq.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { IndividualBrandComponent } from './pages/individual-brand/individual-brand.component';
import { TodaysOfferComponent } from './pages/todays-offer/todays-offer.component';
import { MensSectionComponent } from './pages/mens-section/mens-section.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { UserComponent } from './pages/user/user.component';
import { OurCommunityComponent } from './pages/our-community/our-community.component';
import { BlogComponent } from './pages/blog/blog.component';
import { FoyTvComponent } from './pages/foy-tv/foy-tv.component';
import { CancelOrderComponent } from './pages/cancel-order/cancel-order.component';
import { BrandsDirectoryComponent } from './pages/brands-directory/brands-directory.component';
import { ProductListComponent } from './pages/product-list/product-list.component';
import { IndividualBlogUpdatedComponent } from './pages/individual-blog-updated/individual-blog-updated.component';
import { PaymentstatusComponent } from './components/paymentstatus/paymentstatus.component';
import { ProductDetailUpdatedComponent } from './pages/product-detail-updated/product-detail-updated.component';
import { UserYourProfileComponent } from './pages/user-your-profile/user-your-profile.component';
import { UserMyOrdersComponent } from './pages/user-my-orders/user-my-orders.component';
import { UserMyWishlistComponent } from './pages/user-my-wishlist/user-my-wishlist.component';
import { UserAddressComponent } from './pages/user-address/user-address.component';
import { BlogListComponent } from './pages/blog-list/blog-list.component';
import { ProductComponent } from './pages/product/product.component';
import { ProductTypeBeautyComponent } from './pages/product-type-beauty/product-type-beauty.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { OrderComponent } from './pages/order/order.component';
import { NeedHelpComponent } from './components/need-help/need-help.component';
import { OfferListComponent } from './components/offer-list/offer-list.component';
import { BlogListTwoComponent } from './pages/blog-list-two/blog-list-two.component';
import { CheckoutNewComponent } from './pages/checkout-new/checkout-new.component';

const routes: Routes = [{
  path: '',
  redirectTo: 'home-page',
  pathMatch: 'full'
},
{
  path: 'skin-consultation',
  component: ConsultationComponent,
},
{
  path: 'banner',
  component: BannerComponent,
},
{
  path: 'career',
  component: CareerComponent,
},
{
  path: 'reward',
  component: RewardComponent,
},
{
  path: 'contact-us',
  component: ContactUsComponent,
},
{
  path: 'privacy-policy',
  component: PrivacyPolicyComponent,
},
{
  path: 'shipping-policy',
  component: ShippingPolicyComponent,
},
{
  path: 'terms-of-service',
  component: TermsOfServiceComponent,
},
{
  path: 'returns-and-refund',
  component: ReturnsAndRefundComponent,
},
{
  path: 'faq',
  component: FaqComponent,
},
{
  path: 'sign-in',
  component: SignInComponent,
},
{
  path: 'sign-up',
  component: SignUpComponent,
},
{
  path: 'about-us',
  component: AboutUsComponent,
},
{
  path: 'our-story',
  component: AboutUsComponent,
},
{
  path: 'todays-offer',
  component: TodaysOfferComponent,
},
{
  path: 'mens-section',
  component: MensSectionComponent,
},
{
  path: 'coming-soon',
  component: ComingSoonComponent,
},
{
  path: 'individual-brands/:id',
  component: IndividualBrandComponent,
},
{
  path: 'individual-brand/:name',
  component: ProductTypeBeautyComponent,
},
{
  path: 'blog-list/:categoryId',
  component: BlogListTwoComponent,
},
{
  path: 'blog-list/:categoryId/:subcategoryId',
  component: BlogListTwoComponent,
},
{
  path: 'user/:id',
  component: UserComponent,
},
{
  path: 'our-community',
  component: OurCommunityComponent,
},
{
  path: 'shop-all',
  component: ProductComponent,
},
{
  path: 'shop-all/:categoryId',
  component: ProductComponent,
},
{
  path: 'shop-all/favourites/:tags',
  component: ProductComponent,
},
{
  path: 'shop-all/:categoryId/:gender',
  component: ProductComponent,
},
{
  path: 'shop-all/:discountmode/:discountValueType/:discountValue/:discountType',
  component: ProductComponent,
},
{
  path: 'shop-all/:discountmode/:discountValueType/:discountValue/:discountType/:categoryCode',
  component: ProductComponent,
},
{
  path: 'shop-all/:discountmode/:discountValueType/:discountValue/:discountType/:categoryCode/:subCategoryCode',
  component: ProductComponent,
},
{
  path: 'shop-all/:discountmode/:discountValueType/:discountValue/:discountType/:categoryCode/:subCategoryCode/:leafLevelCategoryName',
  component: ProductComponent,
},
{
  path: 'blog',
  component: BlogComponent,
},
{
  path: 'foy-tv',
  component: FoyTvComponent,
},
{
  path: 'cancel-order',
  component: CancelOrderComponent,
},
{
  path: 'brands-directory',
  component: BrandsDirectoryComponent,
},
{
  path: 'product-list/:productType',
  component: ProductListComponent,
},
{
  path: 'individual-blog-updated/:blogName/:categoryId/:blogId',
  component: IndividualBlogUpdatedComponent,
},
{
  path: 'paymentstatus',
  component: PaymentstatusComponent,
},
{
  path: 'paymentstatus/cod',
  component: PaymentstatusComponent,
},
{
  path: 'product-detail-updated',
  component: ProductDetailUpdatedComponent,
},
{
  path: 'product-detail-updated/:productId/:ProductName',
  component: ProductDetailUpdatedComponent,
},
{
  path: 'user-your-profile',
  component: UserYourProfileComponent,
},
{
  path: 'user-my-orders',
  component: UserMyOrdersComponent,
},
{
  path: 'user-my-wishlist',
  component: UserMyWishlistComponent,
},
{
  path: 'user-address',
  component: UserAddressComponent,
},
{
  path: 'blog-list',
  component: BlogListComponent,
},
{
  path: 'product',
  component: ProductComponent,
},
{
  path: 'product-type-beauty',
  component: ProductTypeBeautyComponent,
},
{
  path: 'home-page',
  component: HomepageComponent,
}
,
{
  path: 'profile',
  component: ProfileComponent,
}
,
{
  path: 'order',
  component: OrderComponent,
},
{
  path: 'need-help',
  component: NeedHelpComponent,
},
{
  path: 'order',
  component: OrderComponent,
}
,
{
  path: 'user-my-orders/:id',
  component: UserMyOrdersComponent,
},
{
  path: 'offers',
  component: OfferListComponent,
},
{
  path: 'blog-list-two',
  component: BlogListTwoComponent,
},
{
  path: 'checkout-new/cart',
  component: CheckoutNewComponent,
},
{
  path: 'checkout-new-mob/cart',
  component: CheckoutNewComponent,
},
{
  path: 'checkout-new/cart/:discountCode',
  component: CheckoutNewComponent,
},
{
  path: 'checkout-new-mob/cart/:discountCode',
  component: CheckoutNewComponent,
},
{
  path: 'checkout-new/buynow/:productId',
  component: CheckoutNewComponent,
},
{
  path: 'checkout-new-mob/buynow/:productId',
  component: CheckoutNewComponent,
},
{
  path: 'checkout-new/buynow/:productId/:discountCode',
  component: CheckoutNewComponent,
},
{
  path: 'checkout-new-mob/buynow/:productId/:discountCode',
  component: CheckoutNewComponent,
},
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload',scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
